import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "ISR", "SATCOM", "ELECTRONIC WARFARE", "SIGINT", "EO/IR",
  "MISSION COMPUTERS", "DATALINKS", "SENSOR FUSION", "SAR/GMTI", "C2 INTEGRATION",
];

export default function Ticker() {
  return (
    <section data-testid="ticker-section" className="overflow-hidden border-y border-orange-500/15 bg-[#070707] py-4">
      <FastMarquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span
            key={item}
            data-testid={`ticker-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="mx-7 text-xs tracking-[0.35em] text-orange-500/80"
          >
            {"//"}&nbsp;&nbsp;{item}
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
